import "regenerator-runtime/runtime.js";

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

import "core-js/modules/es6.object.get-own-property-names.js";
import "core-js/modules/es6.array.slice.js";
import "core-js/modules/es6.object.to-string.js";
import "core-js/modules/es6.promise.js";
import "core-js/modules/es6.symbol.js";
import "core-js/modules/es6.string.iterator.js";
import "core-js/modules/es6.array.iterator.js";
import "core-js/modules/web.dom.iterable.js";
import "core-js/modules/es6.array.from.js";
import "core-js/modules/es6.function.name.js";

function _toArray(arr) { return _arrayWithHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

import MemoryQueueAsync from './queue/MemoryQueueAsync'; // read the api signature of the default queue implementation to assert matching api for any custom `options.queue`

var _Object$getOwnPropert = Object.getOwnPropertyNames(MemoryQueueAsync.prototype),
    _Object$getOwnPropert2 = _toArray(_Object$getOwnPropert),
    constructor = _Object$getOwnPropert2[0],
    QUEUE_API_METHODS = _Object$getOwnPropert2.slice(1); // eslint-disable-line no-unused-vars,prettier/prettier

/**
 * https://developer.mozilla.org/en-US/docs/Mozilla/JavaScript_code_modules/Promise.jsm/Deferred
 */


var createDeferredPromise = function createDeferredPromise() {
  var resolve;
  var reject;
  var promise = new Promise(function (_resolve, _reject) {
    resolve = _resolve;
    reject = _reject;
  });
  return {
    promise: promise,
    resolve: resolve,
    reject: reject
  };
};

export default function createBatchTransportQueue() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var _options$delay = options.delay,
      delay = _options$delay === void 0 ? 100 : _options$delay,
      _options$queue = options.queue,
      queue = _options$queue === void 0 ? new MemoryQueueAsync() : _options$queue,
      transport = options.transport,
      _options$beforeTransp = options.beforeTransport,
      beforeTransport = _options$beforeTransp === void 0 ? function (events) {
    return events;
  } : _options$beforeTransp,
      _options$onError = options.onError,
      onError = _options$onError === void 0 ? function () {} : _options$onError,
      _options$onTransportR = options.onTransportResults,
      onTransportResults = _options$onTransportR === void 0 ? function () {} : _options$onTransportR; // assert options

  if (typeof transport !== 'function') throw new Error('options.transport method required to createBatch'); // eslint-disable-line prettier/prettier
  // assert signature of async queue

  if (_typeof(queue) !== 'object' && typeof queue !== 'function') throw new Error("createQueue: asyncQueue must be an object or a function, got: ".concat(queue)); // assert api methods exist in async queue

  QUEUE_API_METHODS.forEach(function (name) {
    if (typeof queue[name] !== 'function') throw new Error("createQueue: asyncQueue.".concat(name, " must be a function, got: ").concat(queue[name]));
  });
  /**
   * A deferred promise object that will resolve the next time events are
   * flushed. This is returned on calls to schedule().
   */

  var deferredFlushPromise = createDeferredPromise();
  /**
   * Timeout id used to schedule deferred flush() calls.
   */

  var scheduledFlushTimeoutId = null;

  function doTransport() {
    return _doTransport.apply(this, arguments);
  }
  /**
   * Flush any currently queued events, sending them over the network.
   *
   * Flush can either be called directly or indirectly via schedule(). When
   * called directly, we'll clear any scheduled calls too since a flush is
   * already happening.
   */


  function _doTransport() {
    _doTransport = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      var events, processedEvents, results;
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return queue.dequeue();

            case 2:
              events = _context.sent;

              if (!(!events || !events.length)) {
                _context.next = 5;
                break;
              }

              return _context.abrupt("return", null);

            case 5:
              _context.next = 7;
              return beforeTransport(events);

            case 7:
              processedEvents = _context.sent;
              _context.next = 10;
              return transport(processedEvents);

            case 10:
              results = _context.sent;
              // notify other parties about the result of transporting
              onTransportResults({
                events: processedEvents,
                results: results
              });
              return _context.abrupt("return", results);

            case 13:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));
    return _doTransport.apply(this, arguments);
  }

  function doFlush() {
    return _doFlush.apply(this, arguments);
  }
  /**
   * Schedule events to be sent after waiting `delay` ms in order to allow
   * batching events together. Returns a promise that resolves once events
   * have been sent.
   */


  function _doFlush() {
    _doFlush = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
      var deferredPromise;
      return regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              // Reset async state
              if (scheduledFlushTimeoutId !== null) {
                clearTimeout(scheduledFlushTimeoutId);
                scheduledFlushTimeoutId = null;
              }

              deferredPromise = deferredFlushPromise;
              deferredFlushPromise = createDeferredPromise(); // Do transport

              _context2.prev = 3;
              _context2.next = 6;
              return doTransport();

            case 6:
              _context2.next = 19;
              break;

            case 8:
              _context2.prev = 8;
              _context2.t0 = _context2["catch"](3);
              _context2.prev = 10;
              onError(_context2.t0);
              _context2.next = 19;
              break;

            case 14:
              _context2.prev = 14;
              _context2.t1 = _context2["catch"](10);

              if (!(process.env.NODE_ENV === 'test')) {
                _context2.next = 19;
                break;
              }

              deferredPromise.reject(_context2.t1);
              return _context2.abrupt("return", deferredPromise.promise);

            case 19:
              deferredPromise.resolve();
              return _context2.abrupt("return", deferredPromise.promise);

            case 21:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2, null, [[3, 8], [10, 14]]);
    }));
    return _doFlush.apply(this, arguments);
  }

  function scheduleFlush() {
    return _scheduleFlush.apply(this, arguments);
  }

  function _scheduleFlush() {
    _scheduleFlush = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4() {
      return regeneratorRuntime.wrap(function _callee4$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              if (scheduledFlushTimeoutId === null) {
                scheduledFlushTimeoutId = setTimeout( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
                  return regeneratorRuntime.wrap(function _callee3$(_context3) {
                    while (1) {
                      switch (_context3.prev = _context3.next) {
                        case 0:
                          scheduledFlushTimeoutId = null;
                          doFlush();

                        case 2:
                        case "end":
                          return _context3.stop();
                      }
                    }
                  }, _callee3);
                })), delay);
              }

              return _context4.abrupt("return", deferredFlushPromise.promise);

            case 2:
            case "end":
              return _context4.stop();
          }
        }
      }, _callee4);
    }));
    return _scheduleFlush.apply(this, arguments);
  }

  function flush() {
    return _flush.apply(this, arguments);
  }

  function _flush() {
    _flush = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee5() {
      var _ref2,
          _ref2$immediate,
          immediate,
          _args5 = arguments;

      return regeneratorRuntime.wrap(function _callee5$(_context5) {
        while (1) {
          switch (_context5.prev = _context5.next) {
            case 0:
              _ref2 = _args5.length > 0 && _args5[0] !== undefined ? _args5[0] : {}, _ref2$immediate = _ref2.immediate, immediate = _ref2$immediate === void 0 ? true : _ref2$immediate;

              if (!immediate) {
                _context5.next = 3;
                break;
              }

              return _context5.abrupt("return", doFlush());

            case 3:
              return _context5.abrupt("return", scheduleFlush());

            case 4:
            case "end":
              return _context5.stop();
          }
        }
      }, _callee5);
    }));
    return _flush.apply(this, arguments);
  }

  function enqueue(_x) {
    return _enqueue.apply(this, arguments);
  }

  function _enqueue() {
    _enqueue = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee6(event) {
      return regeneratorRuntime.wrap(function _callee6$(_context6) {
        while (1) {
          switch (_context6.prev = _context6.next) {
            case 0:
              _context6.prev = 0;
              _context6.next = 3;
              return queue.enqueue(event);

            case 3:
              _context6.next = 8;
              break;

            case 5:
              _context6.prev = 5;
              _context6.t0 = _context6["catch"](0);
              // Report error to onError callback, but still return a resolve promise
              onError(_context6.t0);

            case 8:
            case "end":
              return _context6.stop();
          }
        }
      }, _callee6, null, [[0, 5]]);
    }));
    return _enqueue.apply(this, arguments);
  }

  return {
    flush: flush,
    enqueue: enqueue
  };
}